import useQueryParam from '../../../hooks/use-query-param';
import {
  REFERRAL_EMAIL_KEY,
  DEFAULT_UTM_MEDIUM,
  DEFAULT_UTM_SOURCE,
  UTM_SOURCE_KEY,
  UTM_TERM_KEY,
  UTM_ID_KEY,
  UTM_CONTENT_KEY,
  UTM_CAMPAIGN_KEY,
  UTM_MEDIUM_KEY,
} from './SubmissionForm.constants';

export function extractReferralEmail(formValues) {
  const foundKeys = Object.keys(formValues).filter((formKey) => {
    return formKey.toLowerCase().includes(REFERRAL_EMAIL_KEY.toLowerCase());
  });

  if (foundKeys.length) {
    return formValues[foundKeys[0]];
  }

  return '';
}

export function getUtmValues() {
  const utmSource = useQueryParam(UTM_SOURCE_KEY);
  const utmMedium = useQueryParam(UTM_MEDIUM_KEY);
  const utmCampaign = useQueryParam(UTM_CAMPAIGN_KEY);
  const utmTerm = useQueryParam(UTM_TERM_KEY);
  const utmContent = useQueryParam(UTM_CONTENT_KEY);
  const utmId = useQueryParam(UTM_ID_KEY);

  return {
    source: utmSource || DEFAULT_UTM_SOURCE,
    medium: utmMedium || DEFAULT_UTM_MEDIUM,
    campaign: utmCampaign || '',
    term: utmTerm || '',
    content: utmContent || '',
    id: utmId || '',
  };
}
